export default __webpack_public_path__ + "static/media/0282.5e577cd6.jpg";